(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[142],{

/***/ 2219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2269);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7729);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(362);
/* harmony import */ var _app_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8213);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2322);

const _excluded = ["ts", "session"];






const IndexPage = _ref => {
  let {
    ts,
    session = null
  } = _ref,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  const {
    t
  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_app_components__WEBPACK_IMPORTED_MODULE_2__/* .LandingLayout */ .a2, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_0__["default"], {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", {
        children: t('landing:title>youtube')
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_app_components__WEBPACK_IMPORTED_MODULE_2__/* .LandingHeader */ .Sx, {
      session: session
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_app_components__WEBPACK_IMPORTED_MODULE_2__/* .LandingNotImplementedYet */ .ZC, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_app_components__WEBPACK_IMPORTED_MODULE_2__/* .LandingFooter */ .Cf, {
      year: new Date(ts).getFullYear()
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);

/***/ }),

/***/ 2768:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/youtube",
      function () {
        return __webpack_require__(2219);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [546,961,524,213,774,888,179], function() { return __webpack_exec__(2768); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);